import { useEffect, useRef, useState } from "react";
import loadImage from "blueimp-load-image";
import imageCompression from "browser-image-compression";
import { useParams } from "react-router-dom";
import {
  useItemFinishListener,
  useItemStartListener,
  useUploady,
  useUploadyContext,
} from "@rpldy/uploady";
import { useDispatch, useSelector } from "react-redux";
import {
  openFPAMinimizedBox,
  uploadFPAModalAction,
} from "../../store/slices/Gallery/galleryFPAupload";
import {
  getAllFPAUploadedImages,
  handleIsUploading,
} from "../../store/slices/Gallery/fileUploadSlice";

let totalUploadingCount = 0;

const useFPAFileUpload = () => {
  let { folderID } = useParams();
  const uploady = useUploady();
  const dispatch = useDispatch();
  const { abort, upload } = useUploadyContext();
  const fileInputRef = useRef();
  const [uploadReadyImages, setUploadReadyImages] = useState([]);
  const [validImages, setValidImages] = useState([]);
  const [isQuited, setIsQuited] = useState(false);
  const fileUploadState = useSelector((state) => state.fileUpload);
  const [uploadWarning, setUploadWarning] = useState(false);
  const [currentlyUploading, setCurrenlyUploading] = useState();
  const [uploadResponses, setUploadResponses] = useState({
    uploaded: 0,
    total: 0,
    uploadedImage: [],
  });

  const { singleFolderData, FPAUploadMode, getCurrentProjectDetails } =
    useSelector((state) => state.projectSinglePage);
  const { tokenDetails, openUploadFPAModal, openFPAMiniBox } = useSelector(
    (state) => state.FPAupload
  );
  const { userProfileData } = useSelector((state) => state.userData);
  // const [isUploading, setIsUploading] = useState();
  const currentFolderDetails = useSelector(
    (state) => state.gallery.currentFolderDetails
  );
  const { openMiniBox } = useSelector((state) => state.gallery);

  // useEffect(() => {
  //   if (
  //     totalUploadingCount === uploadReadyImages?.length &&
  //     uploadReadyImages?.length !== 0
  //   ) {
  //     startImageUpload();
  //   }
  //   setIsUploading(validImages?.length !== uploadedCount);
  // }, [uploadReadyImages]);

  // useItemStartListener((item) => {
  //   setUploadedCount((prev) => prev + 1);
  //   if (isQuited) {
  //     setUploadedCount(0);
  //     abort(item.id);
  //   }
  // });
  // useItemFinishListener((item) => {
  //   uploadReadyImages.forEach((image, i) => {
  //     if (item?.file?.name === image?.name) {
  //       uploadReadyImages[i] = {
  //         ...item,
  //         thumbnail: item?.uploadResponse?.data?.result?.image?.src?.thumbnail2,
  //       };
  //     }
  //   });
  // });

  useEffect(() => {
    async function fetchData() {
      await handleImageUpload(validImages[uploadResponses?.uploaded]);
    }
    if (
      uploadResponses?.total - uploadReadyImages?.length >=
        uploadResponses?.uploaded &&
      uploadResponses?.total != 0
    ) {
      fetchData();
    }

    if (
      uploadResponses?.total - uploadReadyImages?.length ==
        uploadResponses?.uploaded &&
      uploadResponses?.uploaded !== 0
    ) {
      let data = new FormData();
      data.append(
        "user_id",
        getCurrentProjectDetails?.currentPageDetails?.get_clients?.[0]
          ?.FPA_client_id
      );
      dispatch(getAllFPAUploadedImages(data));
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }

    if (
      (uploadResponses?.total - uploadReadyImages?.length ==
        uploadResponses?.uploaded &&
        uploadResponses?.total !== 0) ||
      uploadResponses?.uploadedImage[0]?.result?.code === 402
    ) {
      dispatch(handleIsUploading(false));
    }
  }, [validImages, uploadResponses]);

  const handleDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let imgArry = [...e.dataTransfer.files];
    handleFiles(imgArry);
  };
  const handleDragOut = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleImageChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleFiles = (images) => {
    let files = [...images];
    totalUploadingCount = totalUploadingCount + files?.length;

    [...files]?.forEach((file) => {
      initializeUpload(file);
    });

    setUploadResponses((prev) => {
      return { ...prev, total: totalUploadingCount };
    });
  };
  const checkDuplicate = (image) => {
    const allUploadedImages =
      [
        ...fileUploadState?.allFPAUploadedImages,
        ...uploadResponses?.uploadedImage,
      ] || [];
    return allUploadedImages.some((obj) => obj.original_name === image.name);
  };

  const initializeUpload = (image) => {
    if (checkDuplicate(image)) {
      setUploadReadyImages((prevState) => [
        ...prevState,
        { image, duplicate: true },
      ]);
    } else if (!checkExtension(image)) {
      setUploadReadyImages((prevState) => [
        ...prevState,
        { image, invalid: true },
      ]);
    } else {
      setValidImages((prevState) => [...prevState, image]);
    }
  };

  const checkExtension = (image) => {
    const allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.avif|\.heic)$/i;
    return allowedExtensions.test(image.name);
  };

  const handleImageUpload = async (imageFile) => {
    const options = {
      maxSizeMB: 3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      let compressedFile = await imageCompression(imageFile, {
        ...options,
        alwaysKeepResolution: true,
        initialQuality: 1,
      });

      loadImage.parseMetaData(imageFile, (data) => {
        if (data?.exif) {
          upload(compressedFile, {
            destination: {
              params: {
                album_id:
                  FPAUploadMode == "global" ? singleFolderData.id : folderID,
                user_id:
                  getCurrentProjectDetails?.currentPageDetails?.get_clients?.[0]
                    .FPA_client_id,
                token: tokenDetails.code,
                album_name:
                  FPAUploadMode == "global"
                    ? singleFolderData.name
                    : currentFolderDetails?.name,
                logo_url: userProfileData?.logo_url
                  ? userProfileData?.logo_url
                  : "",
                exif: JSON.stringify(data?.exif?.getAll()),
              },
              filesParamName: "image",
            },
          });
        } else {
          upload(compressedFile, {
            destination: {
              params: {
                album_id:
                  FPAUploadMode == "global" ? singleFolderData.id : folderID,
                user_id:
                  getCurrentProjectDetails?.currentPageDetails?.get_clients?.[0]
                    .FPA_client_id,
                token: tokenDetails.code,
                album_name:
                  FPAUploadMode == "global"
                    ? singleFolderData.name
                    : currentFolderDetails?.name,
                logo_url: userProfileData?.logo_url
                  ? userProfileData?.logo_url
                  : "",
              },
              filesParamName: "image",
            },
          });
        }
      });

      return true;
    } catch (error) {
      uploady.upload(imageFile, {
        destination: {
          params: { album_id: folderID },
          filesParamName: "image",
        },
      });

      return true;
    }
  };

  useItemStartListener((item) => {
    if (openMiniBox) {
      dispatch(handleIsUploading(true));
    }
    setCurrenlyUploading(item);
    if (isQuited) {
      abort(item.id);
    }
  });

  useItemFinishListener((item) => {
    if (fileUploadState?.uploadMode === "FPA") {
      if (item.uploadResponse?.data?.result && !isQuited) {
        setUploadResponses((prev) => {
          return {
            uploaded: prev?.uploaded + 1,
            total: prev?.total,
            uploadedImage: [
              ...prev?.uploadedImage,
              {
                src: item.uploadResponse?.data?.result?.image?.src?.thumbnail1,
                name: item.uploadResponse?.data?.result?.image_info?.file_name,
                result: item.uploadResponse?.data,
              },
            ],
          };
        });
      }
    }
  });

  const closeUploadModal = async () => {
    dispatch(uploadFPAModalAction(false));
    if (
      uploadResponses?.total - uploadReadyImages?.length >
        uploadResponses?.uploaded &&
      uploadResponses?.total != 0
    ) {
      dispatch(openFPAMinimizedBox(true));
      dispatch(handleIsUploading(true));
    } else {
      setUploadReadyImages([]);
      setCurrenlyUploading([]);
      setUploadResponses({
        uploaded: 0,
        total: 0,
        uploadedImage: [],
      });
      totalUploadingCount = 0;

      setValidImages([]);
    }
  };
  const handleCloseFPAMiniMizedModal = () => {
    if (
      uploadResponses?.total - uploadReadyImages?.length >
        uploadResponses?.uploaded &&
      uploadResponses?.total != 0
    ) {
      setUploadWarning(true);
    } else {
      dispatch(openFPAMinimizedBox(false));
      setUploadWarning(false);
    }
  };
  const handleQuitUploading = async () => {
    setIsQuited(true);
    setUploadResponses({
      uploaded: 0,
      total: 0,
      uploadedImage: [],
    });
    totalUploadingCount = 0;

    closeUploadModal();
    dispatch(openFPAMinimizedBox(false));
    setUploadReadyImages([]);
    setCurrenlyUploading([]);
    setValidImages([]);
    setUploadWarning(false);
  };
  return {
    handleDragOver,
    handleDrop,
    handleDragOut,
    handleImageChange,
    openUploadFPAModal,
    closeUploadModal,
    validImages,
    uploadReadyImages,
    handleCloseFPAMiniMizedModal,
    uploadWarning,
    setUploadWarning,
    handleQuitUploading,
    uploadResponses,
    currentlyUploading,
    fileInputRef,
    fileUploadState,
  };
};
export default useFPAFileUpload;
